import MuiDrawer from '@material-ui/core/Drawer';

export default MuiDrawer;
